export default function Reducer(state, action) {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        programs: action.programs,
      };
    case 'DELETE':
      return {
        ...state,
        programs: state.programs
          .filter((item) => (item.id !== action.id)),
      };
    default:
      throw new Error();
  }
}
